<template>
  <div id="Album">
    <section-header  ja="アルバム" en="Album">
      <img src="@/assets/Png/title/album.png">
    </section-header>
    <div class="tabArea">
      <div
        class="tab"
        :class="{'on': tab === 0}"
        @click="tabChange(0)">
        <span>新着順</span>
      </div>
      <div
        class="tab"
        :class="{'on': tab === 1}"
        @click="tabChange(1)">
        <span>撮影別</span>
      </div>
    </div>

    <button
      class="filterBtn"
      @click="openDialog = true"
      v-if="allList && allList.length">{{versionName}}</button>
    <div class="dialog" v-if="openDialog">
      <div class="dialogInner">
        <div class="dialogBtn">
          <button class="all" @click="getPageList(1, 'ALL')">ALL</button>
          <button
            v-for="item in arcadeList"
            :key="item"
            :style="'background-image: url(' + getImg(item.arcadeImg) + ');'"
            @click="getPageList(1, item.name)">{{item.name}}</button>
        </div>
        <button class="closeBtn" @click="openDialog = false" />
      </div>
    </div>

    <div class="imgList">
      <!-- 新着順 -->
      <template v-if="tab === 0">
        <template v-if="newList && newList.length">
          <div class="listArea" v-for="(contents, i) in newList" :key="i">
            <div
              class="cell"
              v-for="(content, j) in contents"
              :key="content.id"
              :class="{'square': (content.arcadeName === 'Bépiu.' || content.arcadeName === 'i my merry') && !content.surprise2}"
              @click="onCell(i, j)">
              <div v-if="content.hasgraff && !content.surprise2" class="graffity" />
              <div v-if="content.surprise || content.surprise2" class="surprise" />
              <img class="thumbnail" v-lazy="content.src">
            </div>
          </div>
        </template>
      </template>

      <!-- 撮影別 -->
      <template v-else-if="tab === 1">
        <template v-if="sheetList && sheetList.length">
          <div v-for="(sheets, i) in sheetList" :key="i">
            <div v-for="(sheet, j) in sheets" :key="j">
              <section-header heading="2" :ja="toDate(sheet.contents[0].time)"/>
              <div class="listArea">
                <div
                  class="cell"
                  v-for="(content, k) in sheet.contents"
                  :key="content.id"
                  :class="{'square': (content.arcadeName === 'Bépiu.' || content.arcadeName === 'i my merry') && !content.surprise2}"
                  @click="onCell(i, j, k)">
                  <div v-if="content.hasgraff && !content.surprise2" class="graffity" />
                  <div v-if="content.surprise || content.surprise2" class="surprise" />
                  <img class="thumbnail" v-lazy="content.src">
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>

      <template v-if="allList && allList.length === 0">
        <textBox title="表示できるプリクラがないよ！">
          セガのプリクラ機で撮ったプリクラがある場合は「プリダウンロード」からシールIDを入力してね
        </textBox>
        <normal-btn @click="onDownload()">プリダウンロード</normal-btn>
      </template>

      <div class="pager" v-if="pagerMaxNum > 1">
        <button
          class="pager_button prev"
          @click="getPageList(nowPageNum - 1, versionName)"
          :disabled="nowPageNum === 1"></button>
        <div>{{nowPageNum}}/{{pagerMaxNum}}</div>
        <button
          class="pager_button next"
          @click="getPageList(nowPageNum + 1, versionName)"
          :disabled="nowPageNum === pagerMaxNum"></button>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue'
import Screen from '../mixins/screen'
import Protobuf from '../mixins/protobuf'
import NormalBtn from '../components/NormalBtn.vue'
import TextBox from '../components/TextBox.vue'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
const pbc = require('../assets/js/kumaproto').kuma.jp.protobuf.common
const { splitArray, toJpegURI, ymd } = require('../assets/js/util')

export default {
  name: "Album",
  components: {
    SectionHeader,
    NormalBtn,
    TextBox
  },
  mixins: [Screen, Protobuf],
  data () {
    return {
      page: 0,
      tab: 0,
      content: [],
      items: [],
      allList: null,
      newList: [],
      sheetList: [],
      openDialog: false,
      pagerMaxNum: 1,
      nowPageNum: 1,
      versionName: 'ALL',
      arcadeList: []
    }
  },
  methods: {
    async getPuriList(list) {
      const contents = []
      const requests = []
      list.forEach(i => {
        const cmdNo = pb.PuriContentReq.CommandNo.COMMAND_NO
        const message = pb.PuriContentReq.create({
          id: i.id,
          types: [pbc.PuriContentType.THUMBNAIL]
        })
        const encoded = pb.PuriContentReq.encode(message).finish()
        requests.push(this.post(cmdNo, encoded))
      })
      const decodes = await Promise.all(requests)
      decodes.forEach((d, i) => {
        if (d.status !== pb.PuriContentResp.Status.SUCCESS) {
          return
        }
        const item = list[i]
        const bytes = d.contents[pbc.PuriContentType.THUMBNAIL]
        contents.push({
          id: item.id,
          sheetId: item.sheetId,
          shopName: item.shopName,
          arcadeName: item.arcadeName,
          src: toJpegURI(bytes),
          time: item.time,
          seqIndex: item.seqIndex,
          tag: null,
          hasgraff: d.hasgraff,
          surprise: item.surprise,
          surprise2: item.surprise2,
        })
      })
      return contents;
    },
    onDownload() {
      this.$router.push('/download')
    },
    setSize (event) {
      if(event.target.naturalWidth >= event.target.naturalHeight) {
        event.target.style.width = 'auto'
        event.target.style.height = '100%'
      } else {
        event.target.style.width = '100%'
        event.target.style.height = 'auto'
      }
    },
    toDate(intTime) {
      return ymd(intTime).join('.')
    },
    onCell(i, j, k) {
      let c = null
      if (this.tab === 0) {
        c = this.newList[i][j]
      } else {
        c = this.sheetList[i][j].contents[k]
      }
      this.$router.push({
        name: 'detail',
        params: {
          id: c.id,
          shopName: c.shopName,
          arcadeName: c.arcadeName,
          time: c.time,
          tag: c.tag,
          surprise: c.surprise,
          surprise2: c.surprise2
        }
      })
    },
    toNewList(contents) {
      const arr = contents
      return splitArray(arr, 30)
    },
    toSheetList(contents) {
      const sheetIds = Array.from(new Set(contents.map(c => c.sheetId)))
      let sheets = sheetIds.map(id => contents.filter(c => c.sheetId === id))
      sheets = sheets.map(s => { return { contents: s, open: false }})
      return splitArray(sheets, 5)
    },
    /**
     * 表示データを絞る
     * index ページャーのページ番号（アーケードの種類を切り替えると1に戻る）
     * arcade アーケード名
     */
    async getPageList(index, arcade) {
      let filtered = [];
      this.nowPageNum = index;
      this.openDialog = false;
      this.versionName = arcade
      arcade === 'ALL' ? filtered = this.items : filtered = this.items.filter(item => item.arcadeName === arcade)
      this.pagerMaxNum = Math.ceil(filtered.length / 30)
      sessionStorage.setItem('albumFilter', arcade);
      sessionStorage.setItem('albumPageNum', index);
      const list = await this.getPuriList(filtered.slice(index*30-30, index*30))
      this.newList = this.toNewList(list);
      this.sheetList = this.toSheetList(list);
      window.scrollTo(0, 0)
    },
    tabChange(num) {
      this.tab = num;
      sessionStorage.setItem('albumTab', num);
    },
    async getArcadeLogo() {
      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          this.arcadeList = decoded.masterArcadeList.reverse().filter(item => this.items.find(i => i.arcadeName === item.name))
        })
    },
    getImg(img) {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
  },
  async mounted() {
    try {
      const cmdNo = pb.AlbumPuriListReq.CommandNo.COMMAND_NO
      const message = pb.AlbumPuriListReq.create()
      const encoded = pb.AlbumPuriListReq.encode(message).finish()
      const decoded = await this.post(cmdNo, encoded)
      this.items = decoded.items.sort((a, b) => a.seqIndex - b.seqIndex).sort((a, b) => b.time - a.time)
      let filtered = this.items
      if(this.items.find(item => item.arcadeName === sessionStorage.getItem('albumFilter'))) {
        this.versionName = sessionStorage.getItem('albumFilter')
        filtered = this.items.filter(item => item.arcadeName === sessionStorage.getItem('albumFilter'))
      }
      this.pagerMaxNum = Math.ceil(filtered.length / 30)
      sessionStorage.getItem('albumPageNum') && this.pagerMaxNum >= sessionStorage.getItem('albumPageNum') ? this.nowPageNum = Number(sessionStorage.getItem('albumPageNum')) : this.nowPageNum = 1
      sessionStorage.getItem('albumTab') ? this.tab = Number(sessionStorage.getItem('albumTab')) : this.tab = 0
      this.allList = await this.getPuriList(filtered.slice(this.nowPageNum*30-30, this.nowPageNum*30));
      this.newList = this.toNewList(this.allList)
      this.sheetList = this.toSheetList(this.allList)
      this.getArcadeLogo()
    } catch (e) {
      this.$_error('Error', { title: 'アルバム', statusCode: 100 })
    }
  },
  watch: {
    tab(v) {
      if (v === 1) { //isSheet
        this.sheetList.forEach(ss => ss.forEach(s => s.open = false))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tabArea {
  display: flex;
  margin-top: 20px;
  .tab {
    width: 50%;
    padding: 10px;
    font-size: 12px;
    color: #8D7F81;
    text-align: center;
    cursor: pointer;
    & > span { padding: 5px 20px; }
    &:last-of-type { border-left: 1px solid #8D7F81; }
    &.on {
      color: #F63C5B;
      & > span {
        background-image:
          linear-gradient(to left, #F63C5B, #F63C5B),
          radial-gradient(#F63C5B 70%, transparent 70%),
          radial-gradient(#F63C5B 70%, transparent 70%);
        background-size: 95% 4px, 4px 4px, 4px 4px;
        background-position: center bottom, left bottom, right bottom;
      }
    }
  }
}
.filterBtn {
  position: relative;
  width: 158px;
  margin: 30px 0 5px 30px;
  padding: 10px;
  text-align: left;
  color: #8D7F81;
  border: 1px solid #8D7F81;
  border-radius: 50px;
  font-size: 12px;
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 13px;
    right: 10px;
    border-top: 10px solid #8D7F81;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid transparent;
  }
}
.imgList {
  .listArea {
    margin: 30px 30px 0;
    display: flex;
    flex-wrap: wrap;
    .cell {
      position: relative;
      width: 100px;
      height: 120px;
      margin-top: 7px;
      overflow: hidden;
      &:not(:nth-of-type(3n)) {
        margin-right: 7px;
      }
      &.square {
        img {
          width: auto;
          height: 100%;
          top: 0;
          position: absolute;
          left: -10px;
          z-index: 1;
        }
      }
      .graffity {
        position: absolute;
        width: 35px;
        height: 35px;
        bottom: 1px;
        right: 1px;
        background-image: url(../assets/Png/Album/Album_Puri_Graffiti.png);
        background-size: contain;
        z-index: 10;
      }
      .surprise {
        position: absolute;
        width: 35px;
        height: 35px;
        top: 1px;
        right: 1px;
        background-image: url(../assets/Png/Album/Album_PuriMotto.png);
        background-size: contain;
        z-index: 10;
      }
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
.pager {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 30px;
    padding: 10px 30px;
    background-color: #E5E3E5;
    font-size: 12px;
    color: #8D7F81;
    &_button {
      width: 20px;
      height: 16px;
      background-image: url(../assets/Png/Common/ic_arrow_pager_2.png);
      background-size: contain;
      background-position: center;
      &.prev { transform: rotate(180deg); }
      &:disabled {
        background-image: url(../assets/Png/Common/ic_arrow_pager_2_disabled.png);
      }
    }
}

@keyframes scrollIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(#000, .5);
  z-index: 5000;
  .dialogInner {
    width: 345px;
    min-height: 200px;
    background-color: #fff;
    padding: 40px 15px;
    border-radius: 8px;
    position: relative;
      .closeBtn {
        position: absolute;
        width: 40px;
        height: 20px;
        top: 10px;
        right: 5px;
        outline: none;
        background-image:
          linear-gradient(
            20deg,
            transparent 0%,
            transparent 44%,
            #585757 50%,
            transparent 55%),
        linear-gradient(
          160deg,
          transparent 0%,
          transparent 44%,
          #585757 50%,
          transparent 55%);
        background-repeat: no-repeat;
        background-size: 28px 10px;
        background-position: 5px 5px, 5px 5px;
      }
    .dialogText {
      font-size: 12px;
      color: #373737;
    }
    .dialogBtn {
      button {
        width: 100%;
        color: #373737;
        margin-bottom: 5px;
        padding: 15px 0;
        background-size: contain;
        background-position: right;
      }
    }
  }
}
</style>
